import ECActionTypes from './types';
import { action } from 'typesafe-actions';
import { GeocodeCoordinatePayload } from 'types';

export const setECGeoJSONPoints = (req: any) =>
  action(ECActionTypes.SET_EMERGENCY_CONTACTS_GEO_JSON, req);

export const fetchEmergencyContactsStart = (req: any) =>
  action(ECActionTypes.EMERGENCY_CONTACTS_START, req);

export const fetchEmergencyContactsSuccess = (res: any) =>
  action(ECActionTypes.EMERGENCY_CONTACTS_SUCCESS, res);

export const fetchEmergencyContactsFailure = (errors: string) =>
  action(ECActionTypes.EMERGENCY_CONTACTS_FAILURE, errors);

export const getECGeocodeStart = (payload: GeocodeCoordinatePayload) =>
  action(ECActionTypes.GET_EC_GEOCODE_START, payload);
export const getECGeocodeSuccess = (payload: any) =>
  action(ECActionTypes.GET_EC_GEOCODE_SUCCESS, payload);
export const getECGeocodeFailure = (payload: string) =>
  action(ECActionTypes.GET_EC_GEOCODE_FAILURE, payload);
export const clearECGeocode = () => action(ECActionTypes.CLEAR_EC_GEOCODE);
export const clearECData = () => action(ECActionTypes.CLEAR_EC_DATA);
